export const UPDATE_TOURNAMENT_TASK_STATUS = 'UPDATE_TOURNAMENT_TASK_STATUS';